














































































































import { DetailItem } from "@/store/viber/statistic/types";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {LongTextWings, ScrollButton} from 'wings-ui-components';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import ViberDetailFilter from "@/components/Viber/ViberDetailFilter.vue";
import { dateFilter } from "@/utils/date-util";

@Component({ components: {ViberDetailFilter, ScrollButton, LongTextWings}, filters: {dateFilter} })
export default class ViberDetail extends BaseItemsPage<DetailItem> {

  @Getter("viberStatisticDetail") responseItems: any;

  is_show_filter_additional = false;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      "create_date",
      "originator",
      "recipient",
      "message",
      "status",
      "partner_price",
      "detail"
    ];
  }

  getData() {
    return this.responseItems;
  }

}
